import { useTranslation } from '@thoughtspot/i18n';
import { Accordion, AccordionVariant, } from '@thoughtspot/radiant-react/widgets/accordion';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { Link } from '@thoughtspot/radiant-react/widgets/link';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import cx from 'classnames';
import React from 'react';
import styles from './section-container.module.scss';
export const SectionContainer = ({ title, description, isCollapsible: isCollapsibleProp, defaultExpanded = true, onReset, children, className, 'data-testid': testId, }) => {
    const { t } = useTranslation();
    const childCount = React.Children.count(children);
    const hasHeader = !!(title || description || onReset);
    const isCollapsible = isCollapsibleProp !== undefined
        ? isCollapsibleProp
        : hasHeader && childCount > 1;
    const resetButton = onReset ? (React.createElement(Link, { className: styles.resetLink, onClick: (e) => {
            e.stopPropagation();
            onReset();
        }, "data-testid": testId ? `${testId}-reset` : undefined }, t('admin.configComponents.sectionContainer.resetToDefault'))) : null;
    if (!hasHeader) {
        return (React.createElement(Vertical, { spacing: "b", className: cx(styles.noHeaderContainer, className), "data-testid": testId }, children));
    }
    if (!isCollapsible) {
        return (React.createElement(Vertical, { className: cx(styles.sectionItem, className), "data-testid": testId },
            React.createElement(Horizontal, { vAlignContent: "center", spacing: "c", className: styles.sectionItemHeader },
                React.createElement(Vertical, { spacing: "b", grow: true, className: styles.headerContent },
                    React.createElement(Typography, { variant: "content-label-subhead", className: styles.sectionTitle },
                        React.createElement("span", { title: title }, title)),
                    description && (React.createElement(Typography, { variant: "body-normal", color: Colors.info, className: styles.description, ellipsis: { rows: 2 } }, description))),
                resetButton),
            React.createElement(Vertical, { spacing: "c", className: styles.sectionItemContent }, children)));
    }
    return (React.createElement("div", { className: cx(styles.accordionWrapper, className), "data-testid": testId },
        React.createElement(Accordion, { expandMultipleItems: true, variant: AccordionVariant.LONG_LIST, useUncontrolledState: true, noPadding: true, expandedItemsIndexes: defaultExpanded ? [0] : [] },
            React.createElement(Accordion.Item, { header: React.createElement(Horizontal, { vAlignContent: "center", spacing: "c", className: styles.accordionHeaderRow },
                    React.createElement(Vertical, { spacing: "b", grow: true, className: styles.headerContent },
                        React.createElement(Typography, { variant: "content-label-subhead", className: styles.sectionTitle },
                            React.createElement("span", { title: title }, title)),
                        description && (React.createElement(Typography, { variant: "body-normal", color: Colors.info, className: styles.description, ellipsis: { rows: 2 } }, description))),
                    resetButton) },
                React.createElement(Vertical, { spacing: "c" }, children)))));
};
//# sourceMappingURL=section-container.js.map